/**
 * The list of IDs for the Modal Popup. These are used to align the identifying value of a popup between redux handlers and popup creation
 * @type {{LOGIN: string}}
 */
export const MODAL_POPUP_ID = {
	LOGIN: 'LOGIN',
    ACCOUNT_MANAGEMENT: 'ACCOUNT_MANAGEMENT',
	ADD_DOMAIN: 'ADD_DOMAIN',
	ADD_DOMAIN_RESOURCE: 'ADD_DOMAIN_RESOURCE',
	SIGN_UP: 'SIGN_UP',
	CONFIRM_ACCOUNT: 'CONFIRM_ACCOUNT',
}


// WEBPACK FOOTER //
// ./src/redux/const.js